import React from 'react';
import { Gamepad2 } from 'lucide-react';
import FilterActionsMenu from './FilterActionsMenu';

export default function FilterRow({
    filter,
    isSetup,
    isLastTwo,
    isDropdownOpen,
    onViewChange,
    onToggleDropdown,
    onRename,
    onDuplicate,
    onDelete,
}) {
    return (
        <tr className="hover:bg-gray-50/50 transition-colors group">
            {/* Name */}
            <td className="py-4 px-6">
                <button
                    type="button"
                    className={`text-sm font-medium ${isSetup ? 'text-blue-600 hover:underline' : 'text-gray-900 cursor-default'}`}
                    onClick={() => isSetup && onViewChange && onViewChange('jobs', filter.id)}
                    disabled={!isSetup}
                >
                    {filter.name}
                </button>
            </td>

            {/* Notifications */}
            <td className="py-4 px-6 text-center">
                {filter.notifications ? (
                    <div className="inline-flex items-center justify-center w-8 h-8 rounded-lg border border-gray-200 text-blue-600 bg-blue-50">
                        <Gamepad2 className="w-4 h-4" />
                    </div>
                ) : (
                    <button
                        type="button"
                        className="text-xs font-medium text-blue-600 cursor-pointer hover:underline"
                        onClick={() => {
                            if (isSetup) {
                                onViewChange('notifications');
                            } else {
                                alert('Please setup the filter first');
                            }
                        }}
                    >
                        Enable
                    </button>
                )}
            </td>

            {/* Status */}
            <td className="py-4 px-6 text-right">
                <div className="flex items-center justify-end gap-2">
                    <span className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium border ${filter.status === 'Active'
                        ? 'bg-green-50 text-green-700 border-green-100'
                        : 'bg-gray-100 text-gray-500 border-gray-200'
                        }`}>
                        <div className={`w-1.5 h-1.5 rounded-full ${filter.status === 'Active' ? 'bg-green-500' : 'bg-gray-400'}`}></div>
                        {filter.status}
                    </span>
                </div>
            </td>

            {/* Actions */}
            <td className="py-4 px-6 text-right">
                <div className="flex items-center justify-end gap-2 relative filter-actions-menu">
                    <button
                        type="button"
                        onClick={() => {
                            // Start Setup Logic or View
                            if (onViewChange) onViewChange('jobs', filter.id);
                        }}
                        className={`px-3 py-1.5 text-xs font-medium rounded-md transition-colors shadow-sm border ${isSetup
                            ? 'text-gray-700 bg-white border-gray-200 hover:bg-gray-50'
                            : 'text-white bg-blue-600 border-transparent hover:bg-blue-700'
                            }`}
                    >
                        {isSetup ? 'View projects' : 'Setup Filter'}
                    </button>

                    <FilterActionsMenu
                        filter={filter}
                        isOpen={isDropdownOpen}
                        isLastTwo={isLastTwo}
                        onToggle={onToggleDropdown}
                        onRename={onRename}
                        onDuplicate={onDuplicate}
                        onDelete={onDelete}
                    />
                </div>
            </td>
        </tr>
    );
}
